import { createApp } from 'vue'
import TooltipComponent from './TooltipComponent'

const el = '.kb-component--tooltip-component'
const DOM = document.querySelectorAll(el)

export default function (Store) {
    DOM.forEach((TooltipDOM) => {
        if (TooltipDOM.hasAttribute('data-v-app')) {
            return 
        }

        const tooltipText = TooltipDOM.dataset.tooltip
        const tooltipName = TooltipDOM.dataset.tooltipname

        const component = createApp(TooltipComponent, {
            tooltipText,
            tooltipName
        })
        component.mount(TooltipDOM)
    })
}
